import s from "./style.module.css";

function ButtonDefault({
  children,
  onClick,
  className = "",
  variant = "dark",
  ...props
}) {
  const buttonClass = variant === "dark" ? s.buttonDark : s.buttonLight;
  return (
    <button
      onClick={onClick}
      className={`${s.button} ${buttonClass} ${className}`}
      {...props}
    >
      {children}
    </button>
  );
}

function IconButton({ icon, alt, onClick, className = "", ...props }) {
  return (
    <button
      onClick={onClick}
      className={`${s.buttonIcon} ${className}`}
      {...props}
    >
      <img src={icon} alt={alt} />
    </button>
  );
}

export { ButtonDefault, IconButton };
